<div class="filter-container um-toolbar form-inline">
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field time-range-select">
      <mat-label>Time Range</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="timeRange" (selectionChange)="onTimeRangeChange()">
        <mat-option value="day">Day</mat-option>
        <mat-option value="week">Week</mat-option>
        <mat-option value="month">Month</mat-option>
        <mat-option value="custom">Custom</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Source</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="source" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="android">Android</mat-option>
        <mat-option value="ios">iOS</mat-option>
        <mat-option value="mobile">Mobile</mat-option>
        <mat-option value="web">Web</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field appearance="fill" style="margin-left: 5px;" class="form-field">
        <mat-label>Active</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="userState" (selectionChange)="onTimeRangeChange()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
    </mat-form-field> -->

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Type</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="userType" (selectionChange)="onTimeRangeChange()">
          <mat-option value="">All</mat-option>
          <mat-option value="Administrator">Admin</mat-option>
          <mat-option value="Customer">Customer</mat-option>
          <mat-option value="US Admin">US Admin</mat-option>
          <mat-option value="Sales Rep">Sales Rep</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Users</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="pvUser" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">PV</mat-option>
          <mat-option value="false">Non-PV</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Auth</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="authType" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="PV">PV</mat-option>
        <mat-option value="Terreo">Terreo</mat-option>
        <mat-option value="MS SSO LOGIN">MS SSO</mat-option>
        <mat-option value="SAML Login">MS SAML</mat-option>
        <mat-option value="Google SSO LOGIN">Google SSO</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Page</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="pageType" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="Footage">Footage</mat-option>
          <mat-option value="Live Views">Live Views</mat-option>
          <mat-option value="NVR NAS">NAS</mat-option>
          <mat-option value="Arm/Disarm">Arm/Disarm</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Active</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="userState" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="Active">Yes</mat-option>
        <mat-option value="User Logout">Logout</mat-option>
        <mat-option value="System Logout">System Logout</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
        <mat-label>Keep Login</mat-label>
        <mat-select panelClass="um-select-panel" [(value)]="keepLogin" (selectionChange)="applySearchFilter()">
          <mat-option value="">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Country</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="country" (selectionChange)="applySearchFilter()">
        <mat-option value="">All</mat-option>
        <mat-option value="US">US</mat-option>
        <mat-option value="IN">India</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
      <mat-label>Unique</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="unique" (selectionChange)="applySearchFilter()">
        <mat-option [value]="true">Yes</mat-option>
        <mat-option [value]="false">No</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchKeyword" (keyup.enter)="applySearchFilter()" #searchInput [disabled]="isLoading">
        <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="applySearchFilter()" (mousedown)="$event.preventDefault()" type="button" tabindex="-1" [disabled]="isLoading">
            <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button matSuffix class="suffix-icon-btn" [class.search-clear-btn--hidden]="!searchKeyword" (click)="clearSearch()" (mousedown)="$event.preventDefault()" type="button" tabindex="-1" [disabled]="isLoading">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field>
    <div class="toolbar-actions">
      <button mat-icon-button (click)="downloadCSV()" matTooltip="Download CSV" aria-label="Download CSV" class="toolbar-icon-btn download-button">
        <mat-icon>download</mat-icon>
      </button>
    </div>
    <!-- <mat-form-field appearance="fill" class="search-field">
      <button mat-icon-button matSuffix (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>   -->

    <div *ngIf="timeRange === 'custom'" class="custom-date-picker">
      <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
        <input matInput [owlDateTime]="startPicker" [owlDateTimeTrigger]="startPicker" placeholder="Start Date" [(ngModel)]="startDate" (dateTimeChange)="onCustomDateChange()">
        <!-- <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker> -->
        <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
        <owl-date-time #startPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
      </mat-form-field>
      <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
        <input matInput [owlDateTime]="endPicker" [owlDateTimeTrigger]="endPicker"  placeholder="End Date" [(ngModel)]="endDate" (dateTimeChange)="onCustomDateChange()">
        <!-- <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker> -->
        <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
        <owl-date-time #endPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
      </mat-form-field>
    </div>
</div>
<div class="table-container um-table-wrap" style="margin-bottom: 20px; position: relative;">
    <!-- Loading Overlay -->
    <div *ngIf="isLoading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.8); z-index: 1000; display: flex; align-items: center; justify-content: center;">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-table um-table um-table-log">
      
      <!-- Define Columns -->
      <ng-container matColumnDef="sessionId">
        <th mat-header-cell *matHeaderCellDef>Session ID</th>
        <td mat-cell *matCellDef="let element">{{element.sessionId}}</td>
      </ng-container>
      <ng-container matColumnDef="username">
        <th class="col-username left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td class="col-username left-sorted-header" mat-cell *matCellDef="let element">{{element.username}}</td>
      </ng-container>
      <ng-container matColumnDef="source">
        <th class="col-narrow centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
        <td class="col-narrow centered-sorted-header" mat-cell *matCellDef="let element">{{element.source}}</td>
      </ng-container>
      <ng-container matColumnDef="userType">
        <th class="col-type left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>User Type</th>
        <td class="col-type left-sorted-header" mat-cell *matCellDef="let element">{{element.userType}}</td>
      </ng-container>

      <ng-container matColumnDef="loginTimeInIST">
        <th class="col-login centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header start="desc">
          <span class="header-stack">
            <span>Login Time</span>
            <span>(IST)</span>
          </span>
        </th>
        <td class="col-login centered-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.loginTimeInIST; else dashDt">
            <span class="dt-date">{{ element.loginTimeInIST | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.loginTimeInIST | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="loginTimeInCT">
        <th class="col-login centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header start="desc">
          <span class="header-stack">
            <span>Login Time</span>
            <span>(CT)</span>
          </span>
        </th>
        <td class="col-login centered-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.loginTimeInCT; else dashDt">
            <span class="dt-date">{{ element.loginTimeInCT | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.loginTimeInCT | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="logoutTimeInCT">
        <th class="col-date centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="header-stack">
            <span>Logout Time</span>
            <span>(CT)</span>
          </span>
        </th>
        <td class="col-date centered-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.logoutTimeInCT; else dashDt">
            <span class="dt-date">{{ element.logoutTimeInCT | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.logoutTimeInCT | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="logoutTimeInIST">
        <th class="col-date centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="header-stack">
            <span>Logout Time</span>
            <span>(IST)</span>
          </span>
        </th>
        <td class="col-date centered-sorted-header" mat-cell *matCellDef="let element">
          <div class="dt-stack" *ngIf="element.logoutTimeInIST; else dashDt">
            <span class="dt-date">{{ element.logoutTimeInIST | dateFormat:'date' }}</span>
            <span class="dt-time">{{ element.logoutTimeInIST | dateFormat:'time' }}</span>
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="timeSinceLogin">
        <th class="col-since centered-sorted-header" mat-header-cell *matHeaderCellDef>
          <span class="header-stack">
            <span>Logged In</span>
            <span>Since</span>
          </span>
        </th>
        <td class="col-since centered-sorted-header" mat-cell *matCellDef="let element">
          {{ element.userState !== 'Active' ? element.userState : (element.loginTimeInIST | timeSinceLogin) }}
        </td>
      </ng-container>
  
      <ng-container matColumnDef="addInfo">
        <th class="col-actions centered-sorted-header" mat-header-cell *matHeaderCellDef>Additional Info</th>
        <td class="col-actions centered-sorted-header" mat-cell *matCellDef="let element">
            <!-- {{ getMoreInfo(element) }} -->
            <div class="table-action-btn">
              <button mat-icon-button class="custom-icon-button circle-icon-btn" (click)="openPageDialog(element)">
                <mat-icon>info</mat-icon>
            </button>
            <button mat-icon-button class="custom-icon-button circle-icon-btn" (click)="openDialog(element)">
              <mat-icon>read_more</mat-icon>
          </button>
            </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="city">
        <th class="col-location left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td class="col-location left-sorted-header" mat-cell *matCellDef="let element">
          <!-- <div [ngSwitch]="element.pageType">
            <ng-container *ngSwitchCase="'Logout'">
              <mat-icon color="warn">exit_to_app</mat-icon> Logout
            </ng-container>
            <ng-container *ngSwitchCase="'Live Views'">
              <mat-icon color="primary">live_tv</mat-icon> Live Views
            </ng-container>
            <ng-container *ngSwitchCase="'Footage'">
              <mat-icon color="accent">video_library</mat-icon> Footage
            </ng-container>
            <ng-container *ngSwitchDefault>
              <mat-icon>info</mat-icon>
               {{ element?.pageType }}
            </ng-container>
          </div> -->
          {{ element?.additionalInfo?.city || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th class="col-region left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
        <td class="col-region left-sorted-header" mat-cell *matCellDef="let element">
          {{ element?.additionalInfo?.region || '-' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <ng-template #dashDt>-</ng-template>

      <!-- <mat-paginator fixed 
        [pageSizeOptions]="[5, 10, 25, 100]" 
        [pageSize]="pageSize" 
        [length]="totalRecords"
        [pageIndex]="pageIndex" 
        (page)="changePaging($event)" aria-label="Select page of users">
      </mat-paginator> -->

      <!-- <mat-paginator [pageSizeOptions]="[5, 25, 50, 100]" showFirstLastButtons></mat-paginator> -->
    </table>
    <!-- <mat-paginator [length]="filteredData.length"
        [pageSize]="pageSize"
        [pageSizeOptions]="[8, 25, 50, 100]"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (page)="onPageChange($event)">
    </mat-paginator> -->
    <mat-paginator
        class="um-paginator"
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageSizeOptions]="[8, 25, 50, 100]"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (page)="onPageChange($event)">
    </mat-paginator>
</div>
  